import { H2, JourneyButton, theme } from '@ahmdigital/ui';
import styled from 'styled-components';

const { media } = theme;

export const StyledJourneyButton = styled(JourneyButton)`
  padding: 0 0.5rem;
  text-align: center;

  &:hover {
    padding: 0 0.5rem;
  }

  @media (max-width: ${media.md}) {
    max-width: inherit;
  }
`;

export const StyledHeading = styled(H2)`
  margin-bottom: 1rem;

  @media (min-width: ${media.md}) {
    margin-bottom: 1.5rem;
  }
`;
